module.exports = __webpack_public_path__ + "static/web-sneaky-redirects-e5e39d7fa0f5e2adf106719b0fc8f0dc.gif";